export default {"buttons":"confirm-dialog-module__buttons___0VAdN","button":"confirm-dialog-module__button___iJygm"}
import '/home/jenkins/agent/workspace/_release_release_t3-widgets_15.1/packages/common/widgets/src/components/modal/confirm-dialog.module.css'
